import React, { useEffect, useState } from "react";
import axiosInstance from "../../axiosInstance";
import { useTranslation } from "react-i18next";

const UpcomingEvents = () => {
  const { t, i18n } = useTranslation();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    axiosInstance
      .get("/api/v1/users/events")
      .then((response) => {
        setEvents(response.data.items);
      })
      .catch(() => {
        setError(i18n.t("events_error"));
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <section className="py-5">
      <div className="container py-4">
        <div className="row justify-content-center mb-5">
          <div className="col-md-8 text-center">
            <h2 className="fw-bold text-primary-custom mb-3">
              {t("events_title")}
            </h2>
            <p className="text-muted">{t("events_subtitle")}</p>
          </div>
        </div>

        {loading ? (
          <div className="text-center">{t("events_loading")}</div>
        ) : error ? (
          <div className="text-center text-danger">{error}</div>
        ) : (
          <div className="row g-4">
            {events.slice(0, 3).map((event) => {
              const eventDate = new Date(event.eventOn);
              const day = eventDate.getUTCDate();
              const month = eventDate.toLocaleString(i18n.language || "ar", {
                month: "long",
              });

              const location = event.isOnline
                ? t("events_online")
                : event.city?.arabicName || t("events_no_location");

              return (
                <div key={event.id} className="col-lg-4 col-md-6">
                  <div className="card event-card shadow-sm h-100">
                    <div className="position-relative">
                      <img
                        src={event.bannerUrl}
                        alt={event.name}
                        className="card-img-top"
                        style={{ height: "200px", objectFit: "cover" }}
                      />
                      <div className="position-absolute top-0 end-0 m-3">
                        <div className="event-date">
                          <small>{month}</small>
                          <strong>{day}</strong>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <h5 className="card-title fw-bold">{event.name}</h5>
                      <p className="card-text text-muted">
                        <i
                          className={`fas ${
                            event.isOnline ? "fa-video" : "fa-map-marker-alt"
                          } me-2`}
                        ></i>
                        {location}
                      </p>
                      <div className="d-flex align-items-center mt-3">
                        <img
                          src={
                            event.organizer?.profileImage ||
                            "/assets-v2/images/default-user.png"
                          }
                          className="rounded-circle me-2"
                          alt={event.organizer?.arabicFullName || ""}
                          width={40}
                          height={40}
                        />
                        <div>
                          <small className="text-muted">
                            {t("events_main_speaker")}
                          </small>
                          <p className="mb-0 small fw-medium">
                            {event.organizer?.arabicFullName}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer bg-transparent border-0 pb-3">
                      {event?.id && event?.arabicName && (
                        <a
                          href={`/event-detail/${event.id}`}
                          className="btn btn-sm btn-outline-primary w-100"
                        >
                          {t("events_details")}
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        <div className="text-center mt-5">
          <a href="/events" className="btn btn-outline-primary px-4 py-2">
            {t("events_all")}
          </a>
        </div>
      </div>
    </section>
  );
};

export default UpcomingEvents;
